import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ResetPasswordSchema } from "../../Schemas/LoginSchema";
import { API_BASE_URL, NonAuthRoutes } from "../../constants/Constants";
import { Icon, PrimaryButton, TextField } from "@fluentui/react";
import ATextField from "../../components/ATextField";
import { useFormik } from "formik";
import { encryptData } from "../../helpers/RSAUtility";
import { resetPassword } from "../../service/UserService";

const textFieldStyles = {
  errorMessage: {
    color: "#ff0000",
    fontWeight: "700",
    fontSize: "12px",
  },
  fieldGroup: {
    borderRadius: "7px",
  },
  field: {
    ":focus": {
      borderRadius: "7px",
    },
  },
  root: {
    color: "rgb(255,255,255) !important",
    border: "none !important",
  },
};
const ResetPassword = () => {
  const [username, setUsername] = useState(
    localStorage.getItem("forgotPasswordUsername")
  );
  const [newPassword] = useState("");
  const [confirmPassword] = useState("");
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isPasswordReset, setIsPasswordReset] = useState(false);

  useEffect(() => {
    const forgotPasswordUsername = localStorage.getItem(
      "forgotPasswordUsername"
    );
    if (forgotPasswordUsername && forgotPasswordUsername != null) {
      setUsername(forgotPasswordUsername);
    } else {
      navigate(NonAuthRoutes.LOGIN);
    }
  }, []);

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        username,
        newPassword,
        confirmPassword,
      },
      validationSchema: () => ResetPasswordSchema(t),
      onSubmit: async (values, action) => {
        const encryptedUsername = encryptData(values.username);
        const encyrptedNewPassword = encryptData(values.newPassword);
        const encryptedConfirmPassword = encryptData(values.confirmPassword);

        const response = await resetPassword(
          encryptedUsername,
          encyrptedNewPassword,
          encryptedConfirmPassword
        );

        if (response.status === 200) {
          setIsPasswordReset(true);
          localStorage.removeItem("forgotPasswordUsername");
          // localStorage.setItem("forgotPasswordUsername", values.username);
        } else {
          setIsAuthenticated(false);
          setErrorMessage(response.data.message);
        }

        action.resetForm();
      },
    });

  // useEffect(() => {
  //   const cookieValue = document.cookie
  //       .split('; ')
  //       .find((row) => row.startsWith("otp-authenticated"))?.split('=')[1];
  //   if(cookieValue != "true") {
  //     navigate(NonAuthRoutes.FORGOTPASSWORD)
  //   }
  // }, [])

  return (
    <>
      <div
        className="ms-Grid container"
        dir="ltr"
        style={{
          height: "100%",
          width: "100%",
          padding: "0px",
          overflowY: "hidden",
          backgroundColor: "white"
        }}
      >
        <div className="ms-Grid-row" style={{ width: "100%", height: "100vh" }}>
          <div
            className="ms-Grid-col ms-xl6 ms-hiddenLgDown"
            style={{ padding: "0", height: "100%" }}
          >
            <img
              className="ai-powered-cloud-image"
              src={`${API_BASE_URL}images/AIPoweredCloudPacs.png`}
              alt="AI Powered Cloud Pacs"
            />
          </div>
          <div
            className="ms-Grid-col ms-sm12 ms-md10 ms-lg8 ms-xl4 ms-xlPush1 ms-lgPush2 ms-mdPush1"
            style={{ padding: "0" }}
          >
            {isPasswordReset && (
              <>
                <div className="login-form-container">
                  <p
                    className="ms-fontSize-12 ms-fontWeight-semibold"
                    style={{
                      marginBottom: "20px",
                      lineHeight: "14px",
                    }}
                  >
                    {t("login.password-changed")}
                  </p>
                  <div style={{ marginTop: "20px" }}>
                    <span
                      className="ms-fontSize-12 cursor-pointer"
                      style={{
                        textDecoration: "underline",
                        marginTop: "5px",
                      }}
                      onClick={() => navigate(NonAuthRoutes.LOGIN)}
                    >
                      Click here
                    </span>
                    <span>
                      {" "}
                      to login
                    </span>
                  </div>
                </div>
              </>
            )}
            {!isPasswordReset && (
              <div className="login-form-container">
                <form>
                  <p
                    className="ms-fontSize-12 ms-fontWeight-semibold"
                    style={{
                      marginBottom: "20px",
                      lineHeight: "14px",
                      color: "rgb(255,255,255,0.8)",
                    }}
                  >
                    {t("login.update-password")}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      margin: "30px 0 5px",
                      color: "#ff0000",
                    }}
                  >
                    {!isAuthenticated && (
                      <div
                        className="ms-fontSize-1"
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Icon
                          iconName="InfoSolid"
                          className="ms-fontSize-14"
                          style={{ marginRight: "5px" }}
                        ></Icon>
                        <p className="ms-fontSize-12 login-form-error-messages ms-fontWeight-bold">
                          {errorMessage}
                        </p>
                      </div>
                    )}
                  </div>
                  <div>
                    <ATextField
                      name="username"
                      label="Username"
                      onChange={handleChange}
                      value={values.username}
                      onBlur={handleBlur}
                      errorMessage={touched.username && errors.username}
                      styles={textFieldStyles}
                      disabled={true}
                    />
                    <TextField
                      name="newPassword"
                      type="password"
                      label="New Password"
                      autoComplete="off"
                      canRevealPassword
                      onChange={handleChange}
                      value={values.newPassword}
                      onBlur={handleBlur}
                      styles={textFieldStyles}
                      errorMessage={touched.newPassword && errors.newPassword}
                    />
                    <TextField
                      name="confirmPassword"
                      type="password"
                      label="Confirm New Password"
                      autoComplete="off"
                      canRevealPassword
                      onChange={handleChange}
                      value={values.confirmPassword}
                      onBlur={handleBlur}
                      styles={textFieldStyles}
                      errorMessage={
                        touched.confirmPassword && errors.confirmPassword
                      }
                    />
                  </div>
                  <div style={{ marginTop: "30px" }}>
                    <PrimaryButton
                      className="ms-fontSize-14"
                      text={t("button.update-password")}
                      style={{ width: "175px" }}
                      onClick={handleSubmit}
                    />
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
